import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewFinancers = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/financer/add`, data);
  return res.data;
};

export const createNewFinancerPayment = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/aadhar_payment/add`, data);
  return res.data;
};

export const getAllFinancers = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/financer?start_date=${data.start_date}&end_date=${data.start_date}`
  );
  return res.data;
};

export const getFinancersById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/financer/data-by-id/${id}`);
  return res.data;
};

export const getAllInvoices = async () => {
  const res = await axios.get(`${API_BASE_URL}/financer/get-all-invoice`);
  return res.data;
};

export const downloadInvoicePDF = async (invoiceId) => {
  const response = await axios.get(
    `${API_BASE_URL}/financer/download-invoice/${invoiceId}`,
    { responseType: "blob" }
  );
  return response;
};

export const updateFinancer = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=financer&id=${id}`,
    data
  );
  return res.data;
};

export const updatePassword = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/user/updatePassword`, data);
  return res.data;
};

export const forgotPassword = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/user/forgotPassword`, data);
  return res.data;
};
